
const compraitemGridConfig = [
  { header: "Produto", field: "produto" },
  { header: "Quantidade", field: "quantidade" },
  { header: "Valor", field: "valor" }
];

export default compraitemGridConfig;